import { render, staticRenderFns } from "./CountryDetail.vue?vue&type=template&id=a7b8b048"
import script from "./CountryDetail.vue?vue&type=script&lang=js"
export * from "./CountryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports